import React, { useEffect, useState } from 'react';
import './styles.sass'

export enum InputType {
    'radio' = 'radio',
    'checkbox' = 'checkbox',
};

export interface OptionType {
    label: string;
    value: string;
};

export interface Props {
    name: string;
    id: string;
    heading: string;
    inputType: InputType;
    onChange: (val: string|string[]) => void;
    options: OptionType[];
    value: string|string[];
};

/**
 * TODO: Describe this component!
 */
const MvInputGrp = ({
    name,
    id,
    heading,
    inputType,
    onChange,
    options,
    value,
}: Props) => {
    const [inputValue, setInputValue] = useState<string|string[]>(value);

    useEffect(() => {
        onChange(inputValue);
    }, [inputValue]);

    return (
        <div className='mv-input-grp'>
            <p className='heading'>{heading}</p>
            <div className='options-container'>
                {options.map((option, i) => {
                    const inputId = `${id}-${i}`;
                    
                    let input = null;
                    if (inputType === InputType.radio) {
                        input = (
                            <input
                                type={InputType.radio}
                                id={inputId}
                                name={name}
                                value={option.value}
                                checked={option.value === inputValue}
                                onChange={e => setInputValue(e.target.value)}
                            />
                        );
                    } else if (inputType === InputType.checkbox) {
                        const selectedIndex = (inputValue as string[]).indexOf(option.value);
                        const checked = selectedIndex !== -1;
                        input = (
                            <input
                                type={InputType.checkbox}
                                id={inputId}
                                name={name}
                                value={option.value}
                                checked={checked}
                                onChange={e => {
                                    if (checked) {
                                        setInputValue((inputValue as string[]).filter(val => val !== option.value));
                                    } else {
                                        setInputValue([...(inputValue as string[]), e.target.value]);
                                    }
                                }}
                            />
                        );
                    }

                    return (
                        <>
                            {input}
                            <label htmlFor={inputId}>{option.label}</label>
                        </>
                    );
                })}
            </div>  
        </div>
    );
};

export {
    MvInputGrp,
};
